export default function WorkflowBenefits() {
  const benefits = [
    {
      icon: 'ri-speed-up-line',
      title: '提升运营效率',
      description: '自动化文档处理流程，减少手动操作时间，让员工专注于更具战略性的任务，显著提高整体工作效率。',
      color: 'teal'
    },
    {
      icon: 'ri-team-line',
      title: '优化协作方式',
      description: '简化的工作流程促进团队成员之间的文档共享与协作，即使跨地域也能无缝配合，加快项目完成速度。',
      color: 'blue'
    },
    {
      icon: 'ri-shield-check-line',
      title: '增强安全性',
      description: '通过基于角色的访问控制系统管理文档，保护敏感信息免受未经授权的访问，避免潜在的数据泄露风险。',
      color: 'purple'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '更好的文档管理',
      description: '集中化的文档控制确保按照一致标准进行存储和维护，降低文件丢失和使用过时版本的风险。',
      color: 'orange'
    },
    {
      icon: 'ri-search-line',
      title: '高效文档检索',
      description: '增强的索引和搜索功能使员工能够快速检索所需文档，减少停机时间和传统文件搜索的困扰。',
      color: 'green'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: '严格的合规性',
      description: '自动化工作流程符合行业法规和标准，确保文档处理满足所有法律要求，降低合规相关问题的风险。',
      color: 'red'
    }
  ];

  const colorClasses: Record<string, { bg: string; icon: string; border: string }> = {
    teal: { bg: 'bg-teal-50', icon: 'text-teal-500', border: 'border-teal-100' },
    blue: { bg: 'bg-blue-50', icon: 'text-blue-500', border: 'border-blue-100' },
    purple: { bg: 'bg-purple-50', icon: 'text-purple-500', border: 'border-purple-100' },
    orange: { bg: 'bg-orange-50', icon: 'text-orange-500', border: 'border-orange-100' },
    green: { bg: 'bg-green-50', icon: 'text-green-500', border: 'border-green-100' },
    red: { bg: 'bg-rose-50', icon: 'text-rose-500', border: 'border-rose-100' }
  };

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            实施文档工作流程的核心优势
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            通过专业的文档工作流程咨询服务，为您的组织带来全方位的效率提升和价值创造
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const colors = colorClasses[benefit.color];
            return (
              <div 
                key={index}
                className={`bg-white p-8 rounded-2xl border ${colors.border} hover:shadow-xl transition-all duration-300 group cursor-pointer`}
              >
                <div className={`w-14 h-14 ${colors.bg} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${benefit.icon} text-2xl ${colors.icon}`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
